import React from 'react';

const Contact = () => {
  return (
    <section className="Contact" id="Contact">
      <h2 className="heading"><br/>Contact <span>Me</span></h2>
      <form action="https://formsubmit.co/damithwijekoon81@gmail.com" method="POST">
        <input type="hidden" name="_subject" value="New message from Damith Wijekoon Portfolio" />
        <input type="hidden" name="_template" value="table" />
        <input type="hidden" name="_captcha" value="false" />
        <div className="input-box">
          <input
            type="text"
            name="name"
            placeholder="Full name"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            required
          />
        </div>
        <div className="input-box">
          <input
            type="tel"
            name="phone"
            placeholder="Mobile Number"
          />
          <input
            type="text"
            name="subject"
            placeholder="Email Subject"
            required
          />
        </div>
        <textarea
          name="message"
          cols="30"
          rows="10"
          placeholder="Your Message"
          required
        ></textarea>
        <br />
        <br />
        <br />
        <input type="submit" value="SEND MESSAGE" className="btn" />
      </form>
    </section>
  );
};

export default Contact;
